module.exports = __webpack_public_path__ + "static/denizli-iplik-firmalar-b5f2ed0917d2bcce2d61871d6a3d3b67.jpg";